<template>
  <router-view></router-view>
</template>

<style lang="scss">
// Main demo style scss
@import "assets/sass/style.vue";
</style>

<script>
export default {
  name: 'App'
}
</script>
